const mediaItems = [
  {
    title: '《藏海花》精彩片段',
    desc: '吴邪揭开青铜门秘密，震撼场面引爆全网热议，播放量已突破5000万次。',
    duration: '15:32',
    views: '5,238万',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20adventure%20scene%20with%20ancient%20mysterious%20tomb%2C%20warm%20torchlight%2C%20dramatic%20cinematic%20composition%2C%20misty%20atmosphere%2C%20explorers%20in%20ancient%20ruins%2C%20warm%20golden%20and%20deep%20amber%20lighting%2C%20movie%20poster%20aesthetic&width=800&height=450&seq=media-1-2026&orientation=landscape',
  },
  {
    title: '《歌手2024》巅峰对决',
    desc: '实力唱将同台飙歌，殿堂级live表演点燃全场，网友直呼这才是真正的音乐。',
    duration: '22:08',
    views: '4,156万',
    image: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20performance%20with%20dramatic%20spotlight%2C%20singer%20silhouette%2C%20colorful%20stage%20lighting%2C%20concert%20atmosphere%2C%20warm%20golden%20and%20amber%20stage%20lights%2C%20epic%20live%20show%20aesthetic&width=800&height=450&seq=media-2-2026&orientation=landscape',
  },
  {
    title: '《飞驰人生2》爆笑花絮',
    desc: '沈腾、范丞丞片场欢乐互动，拍摄幕后趣事大公开，笑点密集不容错过。',
    duration: '08:45',
    views: '3,892万',
    image: 'https://readdy.ai/api/search-image?query=Racing%20movie%20behind%20the%20scenes%20with%20racing%20cars%20and%20film%20crew%2C%20warm%20sunset%20lighting%20on%20racetrack%2C%20cinematic%20action%20movie%20set%2C%20professional%20film%20production%2C%20warm%20golden%20hour%20atmosphere&width=800&height=450&seq=media-3-2026&orientation=landscape',
  },
  {
    title: '《唐朝诡事录》高能片段',
    desc: '杨旭文化身神探破解西域奇案，烧脑推理全程高能，悬念迭起令人拍案叫绝。',
    duration: '18:20',
    views: '2,974万',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20detective%20drama%20scene%20with%20Tang%20dynasty%20aesthetic%2C%20warm%20lantern%20light%2C%20mysterious%20palace%20interior%2C%20period%20costume%20drama%2C%20rich%20warm%20amber%20and%20red%20tones%2C%20cinematic%20historical%20atmosphere&width=800&height=450&seq=media-4-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">精彩视频</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选热门影视高光片段和幕后花絮，精彩内容一睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-black/60 text-background-50 text-xs">
                  <i className="ri-play-fill text-sm"></i>
                  <span>{item.duration}</span>
                </div>
                <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-black/60 text-background-50 text-xs">
                  <i className="ri-eye-line text-sm"></i>
                  <span>{item.views}次</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 line-clamp-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}